module.exports = __webpack_public_path__ + "img/5fd5218.jpg";